import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import { requireProviderTags } from 'store/providers/providerSlice';

import messages from './message';
import ItemManagerModal from '../ItemManagerModal';
import SearchTagEditor from './SearchTagEditor';
import SearchTagPreview from './SearchTagPreview';
import Icon from 'components/Icon';
import Modal from '../../../Modal/Modal';
import { boxShadow1, exactWhite, gray } from '../../../../utils/style/colors';
import styled from 'styled-components';
import LocalIcon from '../../../../ui/LocalIcon';
import Button from '../../../Button/Button';
import i18n from '../../../../i18n';

const SearchTagManagerContainer = styled.div`
  width: calc(100% - 2rem);
  border-radius: 1rem;
  height: calc(100% - 2rem);
  max-height: 100%;
  overflow: visible;
  z-index: 1323;
  display: block;
  opacity: 1;
  transform: scaleX(1);
  top: 10%;
  margin: 1rem;
  box-shadow: ${boxShadow1};
  background-color: var(--exact-white) !important;
`;

class SearchTagManagerModal extends ItemManagerModal {
  UNSAFE_componentWillMount() {
    this.props.dispatch(
      requireProviderTags({
        providerId: this.props.openItem.item.data.providerId,
      })
    );
  }

  renderChild() {
    const { openItem, onClose, onMinimize, tags, dispatch, changeState } =
      this.props;
    const NavOption = ({ text, active }) => {
      return (
        <li key={text}>
          <Button
            key={text}
            color={active ? 'var(--black)' : 'var(--exact-white)'}
            style={{ height: '2.5rem' }}
            onClick={() => changeState(text)}
          >
            {i18n.t(`${text}`, { ns: 'modals' })}
          </Button>
        </li>
      );
    };
    return (
      <>
        <SearchTagManagerContainer>
          <nav
            style={{
              borderRadius: '1rem',
              boxShadow: 'none',
            }}
          >
            <div
              className="nav-wrapper"
              style={{
                display: 'flex',
                justifyContent: 'space-between',
                borderRadius: '1rem',
                paddingTop: '0.5rem',
              }}
            >
              <ul style={{ margin: '0.5rem' }}>
                {onMinimize && (
                  <li>
                    <LocalIcon
                      iconName={'minimize.svg'}
                      color={'no-color'}
                      onClick={onClose}
                      isLink={true}
                      type="sm"
                    />
                  </li>
                )}
                {onClose && (
                  <li>
                    <LocalIcon
                      iconName={'close-square.svg'}
                      color={'no-color'}
                      onClick={onClose}
                      isLink={true}
                      type="sm"
                    />
                  </li>
                )}
              </ul>
              <h4
                style={{
                  fontSize: '1.5rem',
                  marginTop: '0.5rem',
                  padding: '0 1rem',
                }}
              >
                {openItem.item.data.name}
              </h4>
            </div>
          </nav>
          <SearchTagEditor
            dispatch={dispatch}
            item={openItem.item}
            tags={tags}
          />
        </SearchTagManagerContainer>
      </>
    );
  }
}

SearchTagManagerModal.propTypes = {
  openItem: PropTypes.shape({
    item: PropTypes.object.isRequired,
    status: PropTypes.oneOf(['edit', 'view']),
  }).isRequired,
  changeState: PropTypes.func.isRequired,
  dispatch: PropTypes.func.isRequired,
  isOpen: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  onMinimize: PropTypes.func.isRequired,
};

const mapStateToProps = (state, props) => {
  let tags = state.providers.tags[props.openItem.item.data.providerId]?.data;
  if (tags === undefined) {
    tags = {};
  }
  return { ...props, tags };
};

export default connect(mapStateToProps)(SearchTagManagerModal);

{
  /*  <nav>*/
}
{
  /*    <div className="nav-wrapper">*/
}
{
  /*      <span className="brand-logo center hide-on-med-and-down">*/
}
{
  /*        {openItem.item.data.name}*/
}
{
  /*      </span>*/
}
{
  /*      <ul id="navigation-buttons" className="right">*/
}
{
  /*        {onClose && (*/
}
{
  /*          <li>*/
}
{
  /*            <a href="#!" onClick={onClose}>*/
}
{
  /*              <Icon type={'x'} />*/
}
{
  /*            </a>*/
}
{
  /*          </li>*/
}
{
  /*        )}{' '}*/
}
{
  /*        {onMinimize && (*/
}
{
  /*          <li>*/
}
{
  /*            <a href="#!" onClick={onMinimize}>*/
}
{
  /*              <Icon type={'minus'} />*/
}
{
  /*            </a>*/
}
{
  /*          </li>*/
}
{
  /*        )}*/
}
{
  /*      </ul>*/
}

{
  /*      <ul id="surveyNav" className="left">*/
}
{
  /*        {openItem.item.data.editable && (*/
}
{
  /*          <NavOption text="edit" active={openItem.status === 'edit'} />*/
}
{
  /*        )}*/
}
{
  /*        <NavOption text="view" active={openItem.status === 'view'} />*/
}
{
  /*      </ul>*/
}
{
  /*    </div>*/
}
{
  /*  </nav>*/
}
{
  /*  {openItem.status === 'edit' && openItem.item.data.editable ? (*/
}
{
  /*    <SearchTagEditor*/
}
{
  /*      dispatch={dispatch}*/
}
{
  /*      item={openItem.item}*/
}
{
  /*      tags={tags}*/
}
{
  /*    />*/
}
{
  /*  ) : (*/
}
{
  /*    <SearchTagPreview dispatch={dispatch} item={openItem.item} />*/
}
{
  /*  )}*/
}
